import React, { type HTMLAttributes } from 'react';

import {
  Container,
  TitleWithText,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphLinkList as Type } from '../../../types/uncinc_profile/paragraphs';
import useLayoutVariables from '../../../hooks/useLayoutVariables';
import { ButtonWrapper, LinkList } from '../../../components';

import './style.scss';

interface ParagraphLinkListProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphLinkList: React.FC<ParagraphLinkListProps> = ({ id, entity }) => {
  const paragraph = entity.toJS();

  const {
    imageRatio,
    bodyColClasses,
    linksColClasses,
  } = useLayoutVariables('paragraphLinkList');

  const title = paragraph.field_title?.[0]?.value;
  const body = paragraph.field_body?.[0]?.processed;
  const link = paragraph.field_link?.[0];
  const linkUrl = link?.alias ?? link?.uri;
  const linkTitle = link?.title;
  const items = paragraph.field_paragraphs;

  return (
    <div id={id} className="Paragraph ParagraphLinkList">
      <Container>
        <div className="row ParagraphLinkList__wrapper">
          {(title || body) && (
            <div className={bodyColClasses}>
              <TitleWithText
                className="ParagraphLinkList__text"
                title={title}
                text={body}
              />
            </div>
          )}
          <div className={linksColClasses}>
            <LinkList>
              {items.map((item) => {
                const itemTitle = item.entity.field_title?.[0]?.value;
                const itemLabel = item.entity.field_label?.[0]?.value;
                const itemLink = item.entity.field_link?.[0];
                const itemLinkUrl = itemLink?.alias ?? itemLink?.uri;
                const itemImage = item.entity.field_media_item[0];

                return (
                  <LinkList.Item
                    key={item.target_id}
                    title={itemTitle}
                    label={itemLabel}
                    link={itemLinkUrl}
                    image={itemImage}
                    icon="arrow_forward"
                    aspectRatio={imageRatio}
                  />
                );
              })}
            </LinkList>

            {linkUrl && (
              <ButtonWrapper
                href={linkUrl}
                className="ParagraphLinkList__button"
              >
                {linkTitle}
              </ButtonWrapper>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphLinkList;
